import React, { useLayoutEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import Button from 'design-system/Button';
import { rem } from 'design-system/values';
import { AppView } from 'design-system/AppView';
import StatusBar from 'design-system/StatusBar';
import { ButtonGroup } from 'design-system/ButtonGroup';
import { CardView } from 'design-system/CardView';
import useColors from 'hooks/useColors';
import { goBackWithKey } from 'utils/navigationv6';
import { useAppSelector } from 'store/hooks';
import { selectCategory } from 'reducers/selectors';
import { Separator, Spacer } from 'design-system';
import IconCircle from 'design-system/icons/IconCircle';
import EmojiText from 'design-system/EmojiText';
import { isWeb } from '../../../constants';
import IconTransactionCategory from '../icons/IconTransactionCategory';
import { useCreateCustomCategory } from '../hooks/useCreateCustomCategory';
const CustomCategoryCreatedScreen = ({ navigation, route }) => {
    const { category, keyBack } = route.params;
    const { displayName, emoji, parentCategoryId } = category;
    const parentCategory = useAppSelector((store) => selectCategory(store, parentCategoryId));
    const colors = useColors();
    useLayoutEffect(() => {
        navigation.setOptions({
            title: 'Create category',
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const [isCreating, createCustomCategory] = useCreateCustomCategory(() => {
        goBackWithKey(navigation, keyBack);
    });
    if (!emoji)
        return null;
    return (<AppView type="secondary" paddingBottom isInTab={isWeb} avoidHeader style={styles.container}>
        <StatusBar barStyle="dark-content" animated/>
        <CardView>
          <View style={[styles.content, styles.row]}>
            <Text Text-20>{displayName}</Text>
            <IconCircle width={44} height={44}>
              <EmojiText fontSize={24}>{emoji}</EmojiText>
            </IconCircle>
          </View>

          {parentCategory ? (<>
              <Separator />
              <View style={[styles.content, styles.row]}>
                <Text TextThin-14 Secondary>
                  Parent category
                </Text>
                <View style={styles.row}>
                  <IconCircle width={32} height={32}>
                    <IconTransactionCategory width={18} height={18} category={parentCategory}/>
                  </IconCircle>
                  <Spacer.W8 />
                  <Text Text-16>{parentCategory.displayName}</Text>
                </View>
              </View>
            </>) : null}
        </CardView>
        <ButtonGroup type="default">
          <Button brandReversed title="Go back" onPress={() => navigation.pop()} disabled={isCreating}/>
          <Button brand isFetching={isCreating} title="Create custom category" onPress={() => createCustomCategory(category)} testID="continueButton"/>
        </ButtonGroup>
      </AppView>);
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'space-between',
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    content: {
        padding: rem(16),
    },
});
export default CustomCategoryCreatedScreen;
